export default __webpack_public_path__ + "static/media/feature_2.a046690e.png";